/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  CurrentSearchView clusters reducer
 */

import type { Pins } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { RESET_CLUSTERS_AND_LISTABLES } from '../../../../../actions/constants'
import type { ActionTypes } from '../../../reducers/types'
import { CLEAR_PINS, RECEIVE_PINS } from '../constants/index'

import { metaReducer } from './meta'

export const pinsReducer = combineReducers<Pins, ActionTypes>({
  data: handleActions(
    {
      [CLEAR_PINS]: () => [],
      [RESET_CLUSTERS_AND_LISTABLES]: () => [],
      [RECEIVE_PINS]: (state, { payload }) => {
        if (payload.pins) {
          return state.length ? state.concat(payload.pins) : payload.pins
        }
        return state
      },
    },
    [] as Pins['data']
  ),
  meta: metaReducer,
})
